export default {
  "home": "ホーム",
  "news": "最新情報",
  "community": "コミュニティ",
  "character": "キャラクター紹介",
  "world": "世界観",
  "features": "ゲーム紹介",
  "topUp": "チャージ",
  "customerService": "お問い合わせ",
  "download": "今すぐダウンロード",
  "moreDownload": "ダウンロード情報",
  "screenshot": "スクリーンショット",
  "video": "動画",
  "poster": "ギャラリー",
  "downloadGame": "ダウンロード",
  "scan": "QRコードからダウンロード",
  "prev": "前へ",
  "next": "次へ",
  "moreNews": "もっと見る",
  "latest": "最新",
  "fwtk": "利用規約",
  "yszc": "プライバシーポリシー",
  "noContent": "内容がありません。",
  "goPay": "向かう",
  "payGuide": "詳細内容",
  "stayTurn": "お楽しみに",
  "back": "戻る",

  "huoyi": "ヒアリ",
  "huoyi_text": "ヒアリは世界中で有名な侵略的外来種の一種、アリの中で一番恐れられる存在である。\r\n長さは約4-6mm、体は大きくないが、その破壊力は決して軽視すべきではない。",
  "huoyi_skill1": "戦術特技",
  "huoyi_skill2": "兵隊アリ-高速HP",
  "huoyi_skill3": "兵隊アリ-高速DEF",
  "huoyi_skill4": "兵隊アリ-高速ATK",
  "ciyi": "オレンジトゲアリ",
  "ciyi_text": "オレンジトゲアリはオーストラリアでのユーカリの森やサバンナの森でよく見られる。背中は金色を帯びたオレンジ色の剛毛で覆われている。\r\n縁には針状の対称的な背骨が突き出ており、外側の甲羅は硬く、敵を倒す便利な武器である。",
  "ciyi_skill1": "戦術特技",
  "ciyi_skill2": "兵隊アリ-遠距離HP",
  "ciyi_skill3": "兵隊アリ-遠距離DEF",
  "ciyi_skill4": "兵隊アリ-遠距離ATK",
  "hongyi": "アカグロアリ",
  "hongyi_text": "アカグロアリ、今なお適切に命名されていない神秘な生物。長さは約8mm、背中には赤い点がついており、簡単に見分けられる。",
  "hongyi_skill1": "開発速度",
  "hongyi_skill2": "訓練速度",
  "hongyi_skill3": "部隊規模上限",
  "jinjia": "ホンウロコアリ",
  "jinjia_text": "学名はダケトン・アルミゲルム、南アメリカ大陸の北部のアマゾニアで大量に発見される食肉性アリ。\r\n働きアリと兵隊アリの大きさが異なり、兵隊アリの長さは最大で15-17mmに達する。\r\n様々な昆虫やカタツムリなど、ホンウロコアリの飲食はとても多様化である。\r\nホンウロコアリは噛む力が強い歯で獲物を引き裂くほか、針と毒液で獲物を分解することもできる。",
  "jinjia_skill1": "戦術特技",
  "jinjia_skill2": "兵隊アリ-近接HP",
  "jinjia_skill3": "兵隊アリ-近接DEF",
  "jinjia_skill4": "兵隊アリ-近接ATK",
  "gongbei": "クロオオアリ",
  "gongbei_text": "クロオオアリは南アメリカ大陸の北部の一部の地区に生息しており、アマゾニアでの幽霊と呼ばれている。\r\nクロオオアリの主に竹の節の中にアブラムシを飼うことで甘露を収集して食べる。ときにはほかの昆虫も食べる。",
  "gongbei_skill1": "訓練速度",
  "gongbei_skill2": "訓練の食料消費量減少",
  "gongbei_skill3": "体力の消費量減少",
  "specialAnt": "特化アリ",
  "guide": "GUIDE",
  "announcement": "ANNOUNCEMENT",
  "event": 'EVENT',
}
